module.exports = __webpack_public_path__ + "static/img/88.2f9d6db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/88.jpg
// module id = eogV
// module chunks = 159